<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import moment from 'moment'
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'

  export default {
    name: 'ChatConversations',
    components: {
      FallbackAvatar,
    },
    filters: {
      strippedContent: function(string) {
        return string.replace(/<\/?[^>]+>/ig, ' ')
      },
    },
    data() {
      return {
        conversations: [],
        pendingConversations: false,
      }
    },
    computed: {
      ...mapFields('chat', [ 'reloadConversations' ]),
    },
    watch: {
      reloadConversations(val) {
        if (val) {
          this.getConversations()
        }
      },
    },
    created() {
      this.getConversations()
    },
    methods: {
      ...mapActions('chat', ['chat']),
      async getConversations() {
        this.pendingConversations = true
        const chat = await this.chat()
        const conversationsRequest = chat.conversations()
        conversationsRequest && conversationsRequest.then(({ data }) => {
          this.pendingConversations = false
          this.conversations = data
          this.reloadConversations = false
        }).catch(function(error) {
          this.pendingConversations = false
        })
      },
      getDate(conversation) {
        const created = conversation.last_message.time || conversation.created
        const today = moment()
        if (moment.duration(today.diff(created)).asMinutes() < 60) {
          return moment(created).fromNow()
        } else if (moment(created).isSame(today, 'day')) {
          return moment(created).format('HH:mm')
        } else {
          return moment(created).format('DD.MM.YY')
        }
      },
      getSenderName(sender) {
        return sender.name.trim() ? sender.name : sender.id
      },
      showEmpty(conversation) {
        return (conversation.last_message && conversation.last_message.time) || conversation.type === 'group'
      },
    },
  }
</script>
